import { Component } from '@angular/core';
import { NzFooterComponent } from 'ng-zorro-antd/layout';

@Component({
  imports: [NzFooterComponent],
  selector: 'ui-footer',
  template: `
    <nz-footer class="border-t border-gray-300 px-6 py-1.5 text-gray-500">
      <ng-content></ng-content>
    </nz-footer>
  `
})

export class FooterComponent {}
